import { HttpService } from "@/core";
import { LicListPageResp } from "./license-list.interface";

export class LicenseListService {

  static usePageApi() {
    const api = (params) =>
      HttpService.axios({
        method: "GET",
        url: "/cf_mng/cf/page",
        params,
      });
    return HttpService.usePagination<LicListPageResp>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/skill_solution/${id}`,
      });
    return HttpService.useRequest<any>(api);
  }

  static useCreateApi() {
    const api = (data) =>
      HttpService.axios({
        method: "POST",
        url: "/cf_mng/cf/add",
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useEditApi() {
    const api = (id: string, data) =>
      HttpService.axios({
        method: "PUT",
        url: `/cf_mng/cf/${id}`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useDelApi() {
    const api = (data) =>
      HttpService.axios({
        method: "PUT",
        url: `/cf_mng/cf/batch/delete`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }
}
